import { v4 as uuid } from 'uuid';

const AUTH_TOKEN_KEY = 'client-token';

let AUTH_TOKEN: string | null = null;

/**
 * Clears the currently stored client token.
 */
export const clearToken = (): void => {
    AUTH_TOKEN = null;

    try {
        localStorage.removeItem(AUTH_TOKEN_KEY);
    } catch {
        // Shh.. these people don't want us to use local storage
    }
};

/**
 * Checks the currently stored client token.
 */
export const getToken = (): string | null => {
    try {
        if (AUTH_TOKEN === null) {
            AUTH_TOKEN = localStorage.getItem(AUTH_TOKEN_KEY);
        }
    } catch {
        // Shh.. these people don't want us to use local storage
    }

    return AUTH_TOKEN;
};

/**
 * Refreshes the client token for future usage.
 */
export const refreshToken = (): string => {
    AUTH_TOKEN = uuid();

    try {
        localStorage.setItem(AUTH_TOKEN_KEY, AUTH_TOKEN);
    } catch {
        // Shh.. these people don't want us to use local storage
    }

    return AUTH_TOKEN;
};
